<template>
  <div class="news">
    <div v-loading="loading" class="list">
      <div v-for="item in data" :key="item.id" class="list-item" @click="goto(item.id)">
        <div class="left">
          <img :src="ajaxUrl.readFile(item.image)" alt="">
        </div>
        <div class="right">
          <div class="top">
            <div class="top-left">
              <div class="title">
                <span>{{ item.title }}</span>
              </div>
              <div class="description">
                <span>{{ item.summary.length > 90 ? item.summary.substr(0, 90) + '...' : item.summary }}</span>
              </div>
            </div>
            <div class="time">
              <span>{{ item.publishTime | dateFormatFun }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="data.length <= 0" class="rd-noData">
        <img src="../../assets/img/pic/pic_wuxinxi.png" alt="暂无信息">
        <label>暂无信息</label>
      </div>
      <div v-show="data.length > 0" class="pagination-wrapper">
        <el-pagination
            :current-page="page"
            :total="total"
            background
            layout="prev, pager, next"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ECMAScript-6">
import * as ajaxUrl from '../../ajax.config.js';

  export default {
    name: 'news',
    data() {
      return {
        ajaxUrl,
        loading: false,
        data: [],
        page: 1,
        total: 0,
        size: 10
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        const params = {
          page: this.page,
          size: this.size
        };
        this.loading = true;
        this.$get(ajaxUrl.articleListPage(1), params).then(res => {
          this.loading = false;
          this.data = res.content;
          this.total = res.totalElements;
        }).catch(() => {
          this.loading = false;
        });
      },
      goto(id) {
        this.$router.push({ name: 'newsDetail', query: { id } });
      },
      handlePageChange(e) {
        this.page = e;
        this.init();
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
@import "news"
</style>
